module.exports = __webpack_public_path__ + "static/media/NitrogenTruck.2668e840.png";